import React, {useEffect, useState} from 'react';
import Clessidra from '../Pagine/Clessidra'
import stile from './stile.module.css';

function CambioSocieta(props) {

    function seleziona(email, persona) {
        // codice simile per il cambio della persona e della società c'è anche in:    
        // App.js
        // selezionaIdentita() in PaginaInserimentoCredenziali.js

        var url = props.UrlBackend;
        const passwordSalvataCriptata = localStorage.getItem("passCriptataEMA");
        if (persona.urlbackend != "primario") url = persona.urlbackend;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                op:"appSelezionaPersona", 
                email:email,
                passwordCriptata:passwordSalvataCriptata,
                idpersona:persona.idpersona,
                tipo:persona.tipo, 
                nome_database:persona.nome_database,
                emak:props.emak,
                sessionId: props.sessionId 
            })
        };
        fetch(url, requestOptions)
        .then(risposta => risposta.json())
        .then(
            (valoreDiRitorno) => {
                console.log(valoreDiRitorno)
                if (valoreDiRitorno.verifvers===0) {
                    console.log("VERSIONE NON ACCETTATA DAL BACKEND (indica di aggiornare la app)");
                    props.callbackAggiornaApp();
                    return;
                }
                if (valoreDiRitorno.risultatoOperazione === 2) {
                    // in teoria non dovrebbe mai arrivare a scegliere l'identità avendo password errata, ma se succede arriva qua e lo rimando alla login
                    alert("Email o password errate");
                    props.setFlagRichiestaBack(false);
                    props.callback(props.PAGINECLIENTI.home); 
                }
                if (valoreDiRitorno.risultatoOperazione !== 1) { alert("Richiesta fallita","Sistema momentaneamente non disponibile. Se il problema persiste, contattare l'assistenza tecnica"); return; }                                
                props.setIdentitaSelezionata(valoreDiRitorno.identitaSelezionata);
                props.setSessionId(valoreDiRitorno.session_id);
                props.setFlagRichiestaBack(false);
                props.callback(props.PAGINECLIENTI.home);
            },
            (error) => { 
                console.log("ERRORE DA BACKEND NON GESTITO (catch)");
                props.setFlagRichiestaBack(false);
                props.callback(props.PAGINECLIENTI.home);
            }
        );          
    }
    
    const emailIdentita = props.identitaSelezionabili?.email ?? null;
    const elencoSocieta = Array.isArray(props.identitaSelezionabili?.elenco)
      ? props.identitaSelezionabili.elenco
    : [];
    console.log(elencoSocieta)
   
    // gestione del tasto BACK
    useEffect(() => {
        if (props.flagRichiestaBack) {
            props.setFlagRichiestaBack(false);
            props.callback(props.PAGINECLIENTI.home);            
        } 
    }, [props.flagRichiestaBack])
       
    return (
        
        <div className={stile.contenitoreBody} style={{flex:1, display: 'flex', flexDirection: 'column'}}>                

            {elencoSocieta.map((elemento, indice) => (
                <div key={indice} style={{ marginBottom: "1em" }}>                    
                    <div                
                        onClick={() => seleziona(emailIdentita, elemento)}
                        style={{ cursor: "pointer", background: "#eee", padding: "0.5em" }}
                    >
                        {elemento.cognome} {elemento.nome}
                        <br/>
                        <b>{elemento.societa}</b>
                    </div>
                </div>
            ))}
        </div>
    );    
}

export default CambioSocieta;
